import * as React from 'react';
import * as Styled from './styled';
import { inject, observer } from 'mobx-react';
import { RootStore } from 'store/root.store';
import { 
    Dialog, 
    DialogContent, 
    DialogActions, 
    Button, 
    Checkbox
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import EULADialogStore from 'store/eula.dialog.store';
import { withTranslation } from 'react-i18next';

interface Props {
    store?: EULADialogStore;
    // tslint:disable-next-line:no-any
    t: any;
}

@inject((allStores: { rootStore: RootStore }) => {
    let rootStore = allStores.rootStore;
    return {
        store: rootStore.eulaDialogStore
    };
})
@observer
class EULADialog extends React.Component<Props> {

    state = {
        checked: false
    }

    handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ ['checked']: evt.target.checked });
    };
    handleEulaVisibility = (evt: React.ChangeEvent<HTMLInputElement>) => {
        this.props.store!.setHideEula(evt.target.checked);
    }
    render() {
        const { t, store } = this.props;
        const { isOpen, cancel, eulaText, saveEulaAcceptance } = store!;
        
        return (
            <Dialog
                disableBackdropClick={true}
                open={isOpen}
                onClose={cancel}
                scroll={'paper'}
                maxWidth={'md'}
                aria-labelledby="scroll-dialog-title"
                id="eula-dialog"
            >
                <DialogContent>
                    <Styled.Paragraph 
                        dangerouslySetInnerHTML={{__html: eulaText.replace(/(\r\n|\n|\r)/gm, '<br />')}} 
                    />
                    <div style={{margin: '0 auto', display: 'table'}}>
                        <Styled.CheckboxContainer>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        autoFocus={true}
                                        checked={this.state.checked}
                                        onChange={this.handleChange}
                                        value={'checked'}
                                    />
                                }
                                label={t('app.login.dialog.eula.checkbox.terms')}
                            />
                        </Styled.CheckboxContainer>
                        <Styled.CheckboxContainer>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.props.store!.hideEula}
                                        onChange={this.handleEulaVisibility}
                                        value={'hideEula'}
                                    />
                                }
                                label={t('app.login.dialog.eula.checkbox.show_again')}
                            />
                        </Styled.CheckboxContainer>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancel} color="primary">
                        {t('app.login.dialog.eula.action.decline')}
                    </Button>
                    <Button disabled={!this.state.checked} onClick={saveEulaAcceptance} color="primary">
                        {t('app.login.dialog.eula.action.agree')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withTranslation(['common'])(EULADialog);